import { atomWithReset } from 'jotai/utils';

import { NetSuiteExpenseLineExpanded } from '../../data/types';

export const netSuiteExpenseItemsState = atomWithReset<NetSuiteExpenseLineExpanded[]>([]);
